var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"nftlistfilters"},[_c('group-filter',{model:{value:(_vm.dFilters.group),callback:function ($$v) {_vm.$set(_vm.dFilters, "group", $$v)},expression:"dFilters.group"}}),_c('sort-by-filter',{model:{value:(_vm.dFilters.sortBy),callback:function ($$v) {_vm.$set(_vm.dFilters, "sortBy", $$v)},expression:"dFilters.sortBy"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }